import React, { useEffect, useState } from 'react';
import { FontAwesomeConfigurations } from '../../../utils/Configuration/FontAwesomeConfiguration';
import JUNOButton from '../../components/JUNOButton';
import { PrefTypes } from '../../objects/panels/NotificationPreferencesPanel';
import AdminPref from './components/AdminPref';

interface AdminNotficationsModuleProps {}

interface AdminNotificationPrefs {
  id: number;
  preference_id: number;
  web: boolean;
  web_push: boolean;
  app_push: boolean;
  email: boolean;
  global_on: boolean;
  type: PrefTypes;
  title: string;
  help_text: string;
  icon: string;
}
const AdminNotficationsModule: React.FC<AdminNotficationsModuleProps> = ({ ...props }) => {
  /**
   * from entry.php
   * define('NOTIFICATION_PREF_TYPE_DM_REQUEST', 1); //New dm message requests
   * define('NOTIFICATION_PREF_TYPE_DM', 2); // New dm messages
   * define('NOTIFICATION_PREF_TYPE_FORUM_TOPIC', 3);//New forum topics
   * define('NOTIFICATION_PREF_TYPE_FORUM_ACTIVITY', 4);//Forum activity (new forum post on forum you follow)
   * define('NOTIFICATION_PREF_TYPE_FEED_ACTIVITY', 5);//Social feed activity (new feed post on global/cohort)
   * define('NOTIFICATION_PREF_TYPE_TAGGED', 6);//Tagged on a post
   * define('NOTIFICATION_PREF_TYPE_RESPONSES', 7);//Responses on your posts and comments
   * define('NOTIFICATION_PREF_TYPE_LIKES', 8);//Likes on posts and comments
   */
  const [prefData, setPrefData] = useState<AdminNotificationPrefs[]>([]);
  const makeApiRequest = aVars => {
    App.INSTANCE.mApi.Request(
      '../custom_api/api_Services_Notifications.php',
      { api: 'api_update_notification_prefs_for_admin', ...aVars },
      aData => {
        // TODO prod may want something diff but this at least lets the user know their changes saved dynamically
        App.INSTANCE.showTextMessage('Changes saved');
        setPrefData(aData.notifications);
      },
      error => {
        console.error(error);
      },
    );
  };
  useEffect(() => {
    App.INSTANCE.mApi.Request(
      '../custom_api/api_Services_Notifications.php',
      { api: 'get_notification_data_for_admin' },
      aData => {
        setPrefData(aData.notifications);
      },
      aError => {
        console.error(aError);
      },
    );
  }, []);

  return (
    <>
      <div className="instructions">
        <i className={`icon ${FontAwesomeConfigurations.ICON_CIRCLE_INFO_SOLID}`}></i>
        {CrowdHub_App.LANG.ADMIN_NOTIFICATIONS_INSTRUCTIONS}
      </div>
      <div className="message_prefs_container">
        <h3>
          <span>
            <i className={`icon ${FontAwesomeConfigurations.ICON_COMMENT_LINES_SOLID}`}></i>
            {CrowdHub_App.LANG.ADMIN_NOTIFICATIONS_MESSAGES_HEADER}
          </span>
          <JUNOButton
            text="Revert to default settings"
            buttonStyle="juno_button juno_button_filled"
            buttonIcon=""
            onClick={() => {
              makeApiRequest({ pref_types: [1, 2] });
            }}
          ></JUNOButton>
        </h3>
        {prefData
          ?.filter(pref => {
            return pref.type == PrefTypes.message;
          })
          .map(pref => {
            return <AdminPref id={pref.id} pref={pref} key={pref.id} makeApiRequest={makeApiRequest} />;
          })}
      </div>
      <div className="social_prefs_container">
        <h3>
          <span>
            <i className={`icon ${FontAwesomeConfigurations.ICON_USER_GROUP}`}></i>
            {CrowdHub_App.LANG.ADMIN_NOTIFICATIONS_SOCIAL_HEADER}
          </span>
          <JUNOButton
            text="Revert to default settings"
            buttonStyle="juno_button juno_button_filled"
            buttonIcon=""
            onClick={() => {
              makeApiRequest({ pref_types: [3, 4, 5, 6, 7, 8] });
            }}
          ></JUNOButton>
        </h3>
        {prefData
          ?.filter(pref => {
            return pref.type == PrefTypes.social;
          })
          .map(pref => {
            return <AdminPref id={pref.id} pref={pref} key={pref.id} makeApiRequest={makeApiRequest} />;
          })}
      </div>
    </>
  );
};
export default AdminNotficationsModule;
